
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sms-terms",
      function () {
        return require("private-next-pages/sms-terms.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sms-terms"])
      });
    }
  